import { render } from "./AppButton.vue?vue&type=template&id=17d289ee"
const script = {}

import "./AppButton.vue?vue&type=style&index=0&id=17d289ee&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__